import { configureStore } from "@reduxjs/toolkit";
import userReducer from "../features/user/userSlice";
import vimReducer from "../features/vimData/vimSlice";
import breadcrumbReducer from "../features/breadcrumb/breadcrumbSlice";
import assetProfileReducer from "../features/assetProfile/assetProfileSlice";

export const store = configureStore({
  reducer: {
    user: userReducer,
    vimData: vimReducer,
    breadcrumb: breadcrumbReducer,
    assetProfile: assetProfileReducer,
  },
});